import { Component, OnInit, Input } from '@angular/core';
import { RowDropdownMenuItem } from '../../models/row-dropdown-menu-item';
import { TableColumn } from '../../models/table-column';
import { TableRow } from '../../models/table-row';

@Component({
  selector: 'table-row',
  templateUrl: './table-row.component.html',
  styleUrls: ['./table-row.component.scss']
})
export class TableRowComponent implements OnInit {

  @Input('rowItem') rowItem: TableRow;
  @Input('columns') columns: TableColumn[];
  @Input('dropdownMenuItems') dropdownMenuItems?: RowDropdownMenuItem[];

  constructor() { }

  ngOnInit() {
  }

  toggleCollapsed(): void {
    this.rowItem.collapsed = !this.rowItem.collapsed;
  }

}
